import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTelegramChannelAssignments, deleteTelegramChannelAssignment, patchTelegramChannelAssignment, logError } from '../api';
import GenericList from './Global/GenericList';
import { useDisabledToggle } from '../hooks/useDisabledToggle';
import { useSorting } from '../hooks/useSorting';
import DisabledToggle from './ui/DisabledToggle';
import { Row, Col } from 'react-bootstrap';

const TelegramChannelAssignmentList = () => {
    const [assignments, setAssignments] = useState([]);
    const { includeDisabled, setIncludeDisabled } = useDisabledToggle();
    const { orderBy, orderDesc, handleSort } = useSorting();
    const navigate = useNavigate();

    const loadAssignments = useCallback(async () => {
        try {
            const data = await getTelegramChannelAssignments(includeDisabled, orderBy, orderDesc);
            setAssignments(data);
        } catch (error) {
            logError(error);
        }
    }, [includeDisabled, orderBy, orderDesc]);

    useEffect(() => {
        loadAssignments();
    }, [loadAssignments]);

    const handleDelete = async (item) => {
        await deleteTelegramChannelAssignment(item.id);
        setAssignments(prev => prev.filter(a => a.id !== item.id));
    };

    const handleEdit = (item) => {
        navigate(`/telegram-channel-assignments/edit/${item.id}`);
    };

    const handleToggleStatus = async (id, currentStatus) => {
        await patchTelegramChannelAssignment(id, { id, disabled: !currentStatus });
        setAssignments(prev => prev.map(a => a.id === id ? { ...a, disabled: !currentStatus } : a));
    };

    const columns = [
        { key: 'id', header: 'Id' },
        { key: 'entityType.name', header: 'Tipo Entidad' },
        { key: 'entityReferenceId', header: 'ID Referencia', render: (item) => item.entityReferenceId === 0 ? 'Sin asignar' : `${item.entityReference?.firstName} ${item.entityReference?.lastName1}` },
        { key: 'telegramName', header: 'Nombre Telegram' }
    ];

    return (
        <div>
            <Row className="mb-4">
                <Col xs={12} md={6} className="d-flex align-items-center">
                    <DisabledToggle 
                        includeDisabled={includeDisabled}
                        onChange={setIncludeDisabled}
                    />
                </Col>
            </Row>
            <GenericList
                title="Asignaciones de Canal Telegram"
                data={assignments}
                columns={columns}
                onDelete={handleDelete}
                onEdit={handleEdit}
                onToggleStatus={handleToggleStatus}
                onSort={handleSort}
                sortable
                createRoute="/telegram-channel-assignments/new"
                createButtonText="Nueva Asignación"
                deleteMessage="¿Estás seguro de que deseas eliminar esta asignación?"
            />
        </div>
    );
};

export default TelegramChannelAssignmentList;